@if ({
  deliveryNote: deliveryNote$ | async,
  errorDeliveryNote: errorDeliveryNote$ | async
  }; as type) {
  @if (type.deliveryNote || type.errorDeliveryNote) {
    <div [ngClass]="container">
      <!-- BODY -->
      <div class="cx-order-history-body">
        @if (!type.errorDeliveryNote && type.deliveryNote != null > 0) {
          <!-- {{type.deliveryNote | json}} -->
          <div class="header">
            <div class="row">
              <div class="col-md-3">
                <div class="label">
                  {{ 'deliveryNotes.detail.deliveryNumber' | cxTranslate }}
                </div>
              </div>
              <div class="col-md-3">
                <div class="value">
                  {{ type.deliveryNote.deliveryNumber }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="label">
                  {{ 'deliveryNotes.detail.formattedReleaseDate' | cxTranslate }}
                </div>
              </div>
              <div class="col-md-3">
                <div class="value">
                  {{ type.deliveryNote.formattedReleaseDate }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="label">
                  {{ 'deliveryNotes.detail.deliveryText' | cxTranslate }}
                </div>
              </div>
              <div class="col-md-3">
                <div class="value">
                  {{ type.deliveryNote.deliveryText }}
                </div>
              </div>
            </div>
          </div>
          <div class="actions row">
            <div class="col-sm-3">
              <button
                class="btn btn-secondary btn-block mb-3"
                type="button"
                (click)="onExport()"
                >
                {{ 'deliveryNotes.buttons.export' | cxTranslate }}
              </button>
            </div>
            <div class="col-sm-3">
              <button
                class="btn btn-secondary btn-block"
                type="button"
                (click)="goToDeliveryNotesOverview()"
                >
                {{ 'deliveryNotes.buttons.back' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="cx-order-history-sort">
            <div class="form-group row">
              <label for="entries" class="col-xl-2 col-form-label">{{
                'deliveryNotes.sortOptions.label' | cxTranslate
              }}</label>
              <ng-select
                id="sortOptions"
                class="col-xl-3"
                [searchable]="false"
                [clearable]="false"
                (change)="onChangeSort()"
                [(ngModel)]="selectedSortOption"
                >
                @for (sort of sortOptions; track sort) {
                  <ng-option [value]="sort">{{
                    'deliveryNotes.sortOptions.' + sort | cxTranslate
                  }}</ng-option>
                }
              </ng-select>
              <label for="sortDirections" class="col-xl-2 col-form-label">{{
                'deliveryNotes.sortDirections' | cxTranslate
              }}</label>
              <div class="col-xl-2 col-form-label">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="sortDirection"
                    id="sortDirectionDesc"
                    value="desc"
                    ng-control="sortDirection"
                    [(ngModel)]="sortDirection"
                    (change)="onChangeSort()"
                    />
                    <label class="form-check-label" for="sortDirectionDesc">
                      {{ 'deliveryNotes.sortDirection.desc' | cxTranslate }}
                    </label>
                  </div>
                </div>
                <div class="col-xl-2 col-form-label">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="sortDirection"
                      id="sortDirectionAsc"
                      value="asc"
                      ng-control="sortDirection"
                      [(ngModel)]="sortDirection"
                      (change)="onChangeSort()"
                      />
                      <label class="form-check-label" for="sortDirectionAsc">
                        {{ 'deliveryNotes.sortDirection.asc' | cxTranslate }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TABLE -->
              <table class="table cx-order-history-table">
                <thead class="cx-order-history-thead-mobile">
                  <th scope="col" class="ordernumber">
                    {{ 'deliveryNotes.detail.orderNumber' | cxTranslate }}
                  </th>
                  <th scope="col" class="position">
                    {{ 'deliveryNotes.detail.position' | cxTranslate }}
                  </th>
                  <th scope="col" class="productcode">
                    {{ 'deliveryNotes.detail.productCode' | cxTranslate }}
                  </th>
                  <th scope="col" class="description">
                    {{ 'deliveryNotes.detail.description' | cxTranslate }}
                  </th>
                  <th scope="col" class="deliveredquantity">
                    {{ 'deliveryNotes.detail.deliveredQuantity' | cxTranslate }}
                  </th>
                  <th scope="col" class="imei">
                    {{ 'deliveryNotes.detail.imei' | cxTranslate }}
                  </th>
                </thead>
                <tbody>
                  @for (entry of entries; track entry; let i = $index) {
                    <tr>
                      <!-- entry orderNumber -->
                      <td class="ordernumber">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'deliveryNotes.detail.orderNumber' | cxTranslate }}
                        </div>
                        <div class="cx-order-history-value">
                          <a
                            class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'orderDetails',
                            params: { code: entry.orderNumber }
                          } | cxUrl
                        "
                            class="cx-order-history-value"
                            >
                            {{ entry?.orderNumber }}
                          </a>
                        </div>
                      </td>
                      <!-- entry position -->
                      <td class="position">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'deliveryNotes.detail.position' | cxTranslate }}
                        </div>
                        <div class="cx-order-history-value">
                          {{ entry?.position }}
                        </div>
                      </td>
                      <!-- entry product code -->
                      <td class="product-code">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'deliveryNotes.detail.productCode' | cxTranslate }}
                        </div>
                        <div class="cx-order-history-value">
                          <a
                            class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'product',
                            params: { code: entry.productCode }
                          } | cxUrl
                        "
                            class="cx-order-history-value"
                            >
                            {{ entry?.productCode }}
                          </a>
                        </div>
                      </td>
                      <!-- entry description -->
                      <td class="description">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'deliveryNotes.detail.description' | cxTranslate }}
                        </div>
                        <div class="cx-order-history-value">
                          <a
                            class="cx-link"
                        [routerLink]="
                          {
                            cxRoute: 'product',
                            params: { code: entry.productCode }
                          } | cxUrl
                        "
                            class="cx-order-history-value"
                            >
                            {{ entry?.description }}
                          </a>
                        </div>
                      </td>
                      <!-- entry delivered quantity -->
                      <td class="delivered-quantity">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'deliveryNotes.detail.deliveredQuantity' | cxTranslate }}
                        </div>
                        <div class="cx-order-history-value">
                          {{ entry?.deliveredQuantity }}
                        </div>
                      </td>
                      <!-- entry imei/gerätenummer -->
                      <td class="imei">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'deliveryNotes.detail.imei' | cxTranslate }}
                        </div>
                        <div class="cx-order-history-value">
                          {{ entry?.imei }}
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div [ngClass]="'cx-order-history-no-order row'">
                <div [ngClass]="'col-sm-12 col-md-6 col-lg-4'">
                  <div>{{ 'deliveryNotes.noDeliveryNoteItems' | cxTranslate }}</div>
                  <a
                    [routerLink]="{ cxRoute: 'marketplaceDeliveryNotes' } | cxUrl"
                    routerLinkActive="active"
                    class="btn btn-primary btn-block"
                    >{{ 'deliveryNotes.returnToOverview' | cxTranslate }}</a
                    >
                  </div>
                </div>
              }
              <!-- NO ORDER CONTAINER -->
            </div>
          </div>
        } @else {
          <cx-spinner></cx-spinner>
        }
      }


